// src/components/WhatsAppButton.jsx
import React from 'react';

// Número de atendimento da pousada: +55 81 9 8230-7332
const PHONE_NUMBER = '5581982307332';
const PHONE_DISPLAY = '+55 81 9 8230-7332';
const DEFAULT_MESSAGE = 'Olá! Gostaria de mais informações sobre a Pousada da Villa.';

const WhatsAppButton = () => {
  const href = `https://wa.me/${PHONE_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

  return (
    <a
      className="whatsapp-float"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Fale conosco no WhatsApp ${PHONE_DISPLAY}`}
      title={`Fale conosco no WhatsApp ${PHONE_DISPLAY}`}
    >
      <svg className="whatsapp-float-icon" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
        <path
          fill="currentColor"
          d="M16.04 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.6 4.46 1.73 6.4L3.2 28.8l6.57-1.72a12.74 12.74 0 0 0 6.27 1.6h.01c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.33-6.63-3.75-9.05a12.71 12.71 0 0 0-9.06-3.63Zm0 23.34h-.01a10.63 10.63 0 0 1-5.42-1.48l-.39-.23-4.03 1.06 1.07-3.93-.25-.4a10.6 10.6 0 0 1-1.63-5.66c0-5.87 4.78-10.64 10.66-10.64 2.85 0 5.52 1.11 7.53 3.12a10.57 10.57 0 0 1 3.12 7.53c0 5.87-4.78 10.63-10.65 10.63Zm5.84-7.97c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1 1.25-.19.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.58-.95-.85-1.59-1.89-1.78-2.21-.18-.32-.02-.5.14-.66.15-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.73-.98-2.36-.26-.62-.52-.54-.71-.55l-.61-.01c-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.65s1.14 3.08 1.3 3.29c.16.21 2.24 3.42 5.43 4.8.76.33 1.35.52 1.81.67.76.24 1.45.21 2 .13.61-.09 1.89-.77 2.15-1.52.27-.74.27-1.38.19-1.51-.08-.13-.29-.21-.61-.37Z"
        />
      </svg>
      <span className="whatsapp-float-text">{PHONE_DISPLAY}</span>
    </a>
  );
};

export default WhatsAppButton;
